import React from 'react';
import { Row, Col, Label, UncontrolledCollapse , Collapse, Button } from "reactstrap";
import { IconeSetaDescer, IconeSetaSubir } from './Icones';
import { formatNullableValue } from '../../../utils/formatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popup from './Popup';

export default class NaviosCard extends React.Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.handleDadosGeraisClick = this.handleDadosGeraisClick.bind(this);
        this.handleDadosOperacaoClick = this.handleDadosOperacaoClick.bind(this);
        this.openPopUp = this.openPopUp.bind(this)

        this.state = {
            dadosGerais: false,
            dadosOperacao: false,
            popupOpen: false
    
        }
    }

    handleDadosGeraisClick(){

        this.setState(state => ({ dadosGerais: !state.dadosGerais}));
        if(this.state.dadosGerais){
            document.getElementById("icon-geral-fechar" + this.props.id).hidden = true;
            document.getElementById("icon-geral-abrir" + this.props.id).hidden = false;
        }else{
            document.getElementById("icon-geral-abrir" + this.props.id).hidden = true;
            document.getElementById("icon-geral-fechar" + this.props.id).hidden = false;
        }
    }

    handleDadosOperacaoClick(){
        this.setState(state => ({ dadosOperacao: !state.dadosOperacao}));
        if(this.state.dadosOperacao){
            document.getElementById("icon-operacao-fechar" + this.props.id).hidden = true;
            document.getElementById("icon-operacao-abrir" + this.props.id).hidden = false;
        }else{
            document.getElementById("icon-operacao-abrir" + this.props.id).hidden = true;
            document.getElementById("icon-operacao-fechar" + this.props.id).hidden = false;
        }
    }

    onClickCol(col, data){
        if(col.events == undefined) return;
        if(col.events.onClick == undefined) return;
        this.controller.onClickPopUpMovCard(data);
    }

    openPopUp(){
        this.controller.clickPopUpMov()
        this.setState({
            popupOpen: !this.state.popupOpen
        })
    }
    
    render() {
        const colunaId = this.props.colunas.map(col => col.id);
        return (
            <Col xs={12} md={6} lg={4} onClick={ this.handleClick }>
                <div className="card-navio tabela">
                    <Row>

                        <Col xs={12} className="px-0">
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.data[this.props.titulo] }</Label>
                                <Label className="subtitulo">{ this.props.data[this.props.subtitulo] }</Label>
                            </div>
                        </Col>

                        {this.props.colunas.map((col, x) =>
                            (col.dataField !== this.props.titulo) &&
                            (col.dataField !== this.props.subtitulo) &&
                            (col.dataField !== "Situacao") &&
                            // <Col xs={6} className="px-0" key={x}>
                            //     <div className="info bg-cinza">
                            //         <div className="titulo">{col.text}</div>
                            //             <div className="valor" onClick={() => this.onClickCol(col, this.props.data)}>{ col.formatter ?
                            //                 (
                            //                     col.formatExtraData ?
                            //                     formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data), this.props.data, null, col.formatExtraData))
                            //                     :
                            //                     formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
                            //                 )
                            //                 :
                            //                 formatNullableValue(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data))
                            //             }</div>
                            //     </div>
                            // </Col>
                            <Col xs={6} key={x}>
                                <div className="info bg-cinza">
                                    <div className="titulo">{col.text}</div>
                                    <div className="valor">{ col.formatter ?
                                        (col.dataField === "Movs" ?
                                        formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data),this.props.data,null,col.formatExtraData))
                                        :
                                        formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
                                        )
                                        :
                                        col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)
                                    }</div>
                                </div>
                            </Col>
                        )}
                        <Col xs={12} className="px-0">
                            <div className="info">
                                <div className={`situacao-btn ${ this.props.data.Situacao.toLowerCase().replace(/\s|\./g, '-') }`}>{ this.props.data.Situacao }</div>
                            </div>
                        </Col>

                        <Col xs={12}>
                            <div className="area-colapsada">
                                <Button className="btn" onClick={this.handleDadosGeraisClick} >
                                    Dados Gerais
                                    <span id={`icon-geral-abrir${ this.props.id }`}><IconeSetaDescer /></span>
                                    <span id={`icon-geral-fechar${ this.props.id }`} hidden ><IconeSetaSubir /></span>
                                </Button>
                                <Collapse isOpen={this.state.dadosGerais} >

                                    <Row>
                                    {this.props.dadosGerais.map((col, x) =>
                                    {
                                        if(colunaId.indexOf(col.id) === -1){
                                            if(col.movs){
                                                return (<Col xs={12} key={x} onClick={() => this.onClickCol(col, this.props.data)}>
                                                    <div className="card-detalhe">
                                                        <div>
                                                            <div className="label">{col.label}</div>
                                                            <h5>{col.titulo} <FontAwesomeIcon icon="external-link-square-alt" className="card-detalhe--pop-color" size="xs"/></h5>
                                                            <div className="desc">{ this.props.data[col.field] }</div>
    
                                                        </div>
                                                    </div>
                                                </Col>)
                                            }else{
                                                return (<Col xs={12} key={x}>
                                                    <div className="card-detalhe">
                                                        <div>
                                                            <h5>{col.titulo}</h5>
                                                            <div className="desc">{ col.formatacao ?
                                                                (
                                                                    col.field.length > 1 ?
                                                                    formatNullableValue(col.formatacao(this.props.data[col.field[0]],this.props.data[col.field[1]]))
                                                                    :
                                                                    formatNullableValue(col.formatacao(col.field[0], this.props.data))
                                                                )
                                                                :
                                                                formatNullableValue(col.field[0].split('.').reduce((o,i)=>o[i], this.props.data))
                                                            }</div>
                                                        </div>
                                                        
                                                    </div>
                                                </Col>)
    
                                            }
                                        }
                                    }

                                    )}
                                    </Row>

                                </Collapse>
                                
                            </div>
                        </Col>

                        <Col xs={12}>
                            <div className="area-colapsada">
                                <Button className="btn" onClick={this.handleDadosOperacaoClick}  >
                                    Dados da Programação
                                    <span id={`icon-operacao-abrir${ this.props.id }`}><IconeSetaDescer /></span>
                                    <span id={`icon-operacao-fechar${ this.props.id }`} hidden><IconeSetaSubir /></span>
                                </Button>
                                <Collapse  isOpen={this.state.dadosOperacao} >
                                    <Row>
                                    {this.props.dadosOperacao.map((col, x) =>
                                        {
                                        if(colunaId.indexOf(col.id) === -1){
                                            return (<Col xs={12} key={x}>
                                                <div className="card-detalhe">
                                                    <div>
                                                        <div className="label">{col.label}</div>
                                                        <h5>{col.titulo}</h5>
                                                        <div className="desc">{ col.formatacao ?
                                                            col.formatacao(this.props.data[col.field])
                                                            :
                                                            this.props.data[col.field] }
                                                        </div>

                                                    </div>
                                                    
                                                </div>
                                            </Col>)
                                            }
                                        }
                                    )}
                                    </Row>
                                </Collapse >
                            </div>
                        </Col>
                    </Row>
               </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/NaviosCard.js